import * as Yup from 'yup'
import { isValidPhone } from 'Utils/PhoneHelpers'

const messageRequired = 'Required field.'
const couponMessage = 'Must be at least 4 characters long and only consist of numbers and capital letters'
const validZipCodeRegx = /^\d{5}$/

Yup.addMethod(Yup.string, 'isValidPhone', isValidPhone)

const PaymentViewSchema = ({ isTripProtection }) => {
  const schema = Yup.object().shape({
    card: Yup.bool(),

    address: Yup.string()
      .when('selectedCard', {
        is: selectedCard => !selectedCard,
        then: Yup.string()
          .required(messageRequired),
      }),

    address2: Yup.string(),

    city: Yup.string()
      .when('selectedCard', {
        is: selectedCard => !selectedCard,
        then: Yup.string()
          .required(messageRequired),
      }),

    couponCode: Yup.string()
      .matches(/^[A-Z0-9]{4,50}$/, couponMessage),

    discount: Yup.object().shape({
      code: Yup.string()
        .when('numberRequired', {
          is: numberRequired => numberRequired,
          then: Yup.string()
            .required(messageRequired),
        }),

      id: Yup.string(),

      numberRequired: Yup.bool(),
    }),

    membershipCode: Yup.string()
        .when('isMembershipRequired', {
          is: isMembershipRequired => isMembershipRequired,
          then: Yup.string()
            .required(messageRequired),
        }),

    phone: Yup.string()
      .required(messageRequired)
      .isValidPhone(),

    state: Yup.string()
      .when('selectedCard', {
        is: selectedCard => !selectedCard,
        then: Yup.string()
          .required(messageRequired),
      }),

    tripInsurance: Yup.string(),

    homeAddress: Yup.object()
      .when({
        is: () => isTripProtection,
        then: Yup.object({
          address: Yup.string()
            .required(messageRequired),

          address2: Yup.string(),

          city: Yup.string()
            .required(messageRequired),

          state: Yup.string()
            .required(messageRequired),

          zipCode: Yup.string()
            .matches(validZipCodeRegx, 'Please enter a valid zip code')
            .required(messageRequired),
        }),
      }),
  })

  return schema
}

export default PaymentViewSchema
